module.exports = __webpack_public_path__ + "img/amg_logo.6a83fae3.svg";